import React from "react";
import IPrizeTable from "../interfaces/IPrizeTable";
import formatDollar from "../utils/formatDollar";

interface IProps {
    highlightPrizeWon?: boolean;
    matches?: number;
    multiplier?: number;
    prizeTable?: IPrizeTable;
    selectionCount: number;
}

export default class PrizeTable extends React.Component<IProps> {
    public render(): JSX.Element {
        const { selectionCount, matches, prizeTable, highlightPrizeWon } = this.props;

        if (!selectionCount) {
            return (
                <div></div>
            );
        }

        const table: IPrizeTable = prizeTable || {};

        const { multiplier } = this.props;
        const prizes = table[selectionCount] || {};

        const keysInOrder = Object.keys(prizes);
        keysInOrder.sort((a: string, b: string) => {
            const BASE_10 = 10;
            return parseInt(b, BASE_10) - parseInt(a, BASE_10);
        });

        return (
            <table className="prize-table">
                <thead>
                    <tr>
                        <th>Match</th>
                        <th>Win</th>
                    </tr>
                </thead>
                <tbody>
                    { keysInOrder.map((key: string): JSX.Element => {
                        const BASE_10 = 10;
                        const matchCount = parseInt(key, BASE_10);

                        const DOLLAR_IN_CENTS = 100;
                        const prize = (prizes[matchCount] || 0) / DOLLAR_IN_CENTS;

                        const classes: string[] = [];
                        if (highlightPrizeWon && matches === matchCount) {
                            classes.push("match");
                        }

                        return (
                            <tr key={ matchCount } className={ classes.join(" ") }>
                                <td>{ matchCount }/{ selectionCount }</td>
                                <td>${ formatDollar((multiplier || 1) * (prize || 1)) }</td>
                            </tr>
                        );
                    }) }
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PrizeTable.tsx